import { Header } from "#components";
import React from "react";

const WebLayout = ({ children }) => {
  return (
    <div className="main-wrapper">
      <Header />
      <div className="content-wrapper">{children}</div>
    </div>
  );
};

export default WebLayout;
